import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from './ga';

/**
 * GA4 has no built-in SPA route tracking (unlike App Insights'
 * enableAutoRouteTracking) — this fires a pageview on every client-side
 * navigation. No-ops until initGA() has run (post cookie-consent).
 */
const GARouteTracker = (): null => {
	const location = useLocation();

	useEffect(() => {
		trackPageView(location.pathname + location.search);
	}, [location.pathname, location.search]);

	return null;
};

export default GARouteTracker;
